import TextViewer from "../../components/TextViever";

const Land = () => {
  return <TextViewer obszar="land" />;
};

export default Land;
